module.exports = __webpack_public_path__ + "img/stock-image-meeting-room.43fb9a09.jpeg";